<template>
  <el-tabs v-model="tabPaneVal" type="border-card" @tab-click="handleClick">
    <el-tab-pane label="企业资料" name="ShipmentEdit">
      <ShipmentEdit v-if="isShipmentEditShow" ref="ShipmentEditRef" :parent-data="parentData" />
    </el-tab-pane>
    <el-tab-pane label="开票信息管理" name="InvoiceMessage">
      <InvoiceMessage v-if="isInvoiceMessageShow" ref="InvoiceMessageRef" :parent-data="parentData" />
    </el-tab-pane>
    <el-tab-pane label="地址管理" name="CommonRouteInfo">
      <CommonRouteInfo v-if="isCommonRouteInfoShow" ref="CommonRouteInfoRef" :parent-data="parentData" />
    </el-tab-pane>
    <el-tab-pane label="承运分组" name="VehicleTeam">
      <VehicleTeam v-if="isVehicleTeamShow" ref="VehicleTeamRef" :parent-data="parentData" />
    </el-tab-pane>
    <el-tab-pane label="员工管理" name="ShipmentStaff">
      <ShipmentStaff v-if="isShipmentStaffShow" ref="ShipmentStaffRef" :parent-data="parentData" />
    </el-tab-pane>
    <el-tab-pane v-if="isAdmin" label="子公司管理" name="SubsidiaryManagement">
      <SubsidiaryManagement
        ref="SubsidiaryManagementRef"
        :parent-data="parentData"
      />
    </el-tab-pane>
    <!-- <el-tab-pane label="上游客户管理" name="UpstreamCustomer">
      <UpstreamCustomer v-if="isUpstreamCustomerShow" ref="UpstreamCustomerRef" :parent-data="parentData" />
    </el-tab-pane> -->
    <el-tab-pane label="合同管理" name="ShipmentContract">
      <ShipmentContract v-if="isShipmentContractShow" ref="ShipmentContractRef" :parent-data="parentData" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import SubsidiaryManagement from "./SubsidiaryManagement.vue";
import ShipmentEdit from "./components/shipmentEdit.vue";
import InvoiceMessage from "./components/invoiceMessage/invoiceMessageList.vue";
import CommonRouteInfo from "./components/commonRouteInfo/commonRouteInfoList.vue";
import VehicleTeam from "./components/vehicleTeam/vehicleTeamList.vue";
import ShipmentStaff from "./components/shipmentStaff/shipmentStaffList.vue";
// import UpstreamCustomer from "./components/upstreamCustomer/upstreamCustomerList.vue";
import ShipmentContract from "./components/shipmentContract/shipmentContractList.vue";
import { getListDict, getGoodsTypeDict, getShipperList } from "@/api/shipment";
export default {
  name: "InfoShipmentCompanyForm",
  components: {
    ShipmentEdit,
    InvoiceMessage,
    CommonRouteInfo,
    VehicleTeam,
    ShipmentStaff,
    // UpstreamCustomer,
    ShipmentContract,
    SubsidiaryManagement
  },
  data() {
    return {
      isAdmin: false,
      companyCode: '',
      parentData: {
        isCompany: true,
        isDetail: true,
        areaOptions: this.$store.state.components.areaOptions,
        goodsTypeList: [],
        typeOptions: [],
        vehicleDictList: [],
        bankOptions: [],
        receiverUserCodeOptions: [],
        upstreamCustomerList: [],
        branchCode: '',
      },
      tabPaneVal: "ShipmentEdit",
      isShipmentEditShow: true,
      isInvoiceMessageShow: false,
      isCommonRouteInfoShow: false,
      isVehicleTeamShow: false,
      isShipmentStaffShow: false,
      isUpstreamCustomerShow: false,
      isShipmentContractShow:false
    };
  },
  created() {
    const partyType = this.$store.getters.party.partyType;
    const isAdmin =
      partyType == "SUPER_ADMIN" ||
      partyType == "PLAT_ADMIN" ||
      partyType == "STAFF";
    this.isAdmin = isAdmin;
    this.companyCode = this.$route.query.code ? this.$route.query.code : "";
    this.parentData.branchCode = this.$route.query.branchCode
    // 收票人选项
    getShipperList({ staffTypes: "1,4,6", companyCode: this.companyCode }).then(response => {
      this.parentData.receiverUserCodeOptions = response.data.records;
    });
    // 上游客户
    getShipperList({ staffType: '5', companyCode: this.companyCode }).then(response => {
      this.parentData.upstreamCustomerList = response.data.records
    });
    // 货物类型字典
    getGoodsTypeDict({ parentCode: "goodsBigType" }).then(response => {
      this.parentData.goodsTypeList = response.data.records;
    });
    // 开票方式、车型、开户银行
    getListDict({ types: "vehicleClassification, bank" }).then(
      response => {
        this.parentData.vehicleDictList = response.data.filter(
          item => item.type === "vehicleClassification"
        )[0]["dictList"];
        this.parentData.bankOptions = response.data.filter(
          item => item.type === "bank"
        )[0]["dictList"];
      }
    );
  },
  methods: {
    handleClick(tab, event) {
      this[`is${tab.name}Show`] = true;
      this.$nextTick(() => {
        this.$refs[`${tab.name}Ref`].findList() ;
      })
      // 重新获取 上游客户
      if (tab.name === 'UpstreamCustomer') {
        getShipperList({ staffType: '5', companyCode: this.companyCode }).then(response => {
          this.parentData.upstreamCustomerList = response.data.records
        });
      }
    }
  }
};
</script>
